module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thumbnail_card"
  }, [_c('div', {
    staticClass: "imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.scenario.thumbnail
    }
  })]), _vm._v(" "), (_vm.scenario.showCheck === true) ? _c('h3', {
    staticClass: "thumbnail_title"
  }, [_vm._v(" " + _vm._s(_vm.scenario.name))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "thumbnail_desc m-0 pt-2 oneline_text"
  }, [_vm._v(_vm._s(_vm._f("truncate")((_vm.scenario.description.length < 100) ? _vm.scenario.description : _vm.scenario.description, 100)))]), _vm._v(" "), _c('ul', {
    staticClass: "thumbnail_card_icon"
  }, [_c('li', [_c('span', {
    staticClass: "card_counter"
  }, [_vm._v(_vm._s(_vm.scenario.level))])]), _vm._v(" "), (_vm.scenario.type == 'click') ? _c('li', [_c('img', {
    attrs: {
      "src": "https://app.humanfirewall.io/static/img/click.svg",
      "width": "17px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.type == 'attachment') ? _c('li', {
    attrs: {
      "title": "Attachment"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.type == 'data-entry') ? _c('li', {
    attrs: {
      "title": "Data Entry"
    }
  }, [_c('i', {
    staticClass: "fas fa-keyboard envelope_size"
  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.type == 'announcement') ? _c('li', {
    attrs: {
      "title": "Announcement"
    }
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  })]) : _vm._e(), _vm._v(" "), (!_vm.scenario.channel_type || _vm.scenario.channel_type == 0) ? _c('li', {
    attrs: {
      "title": _vm.title
    }
  }, [_c('i', {
    staticClass: "far fa-envelope envelope_size"
  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.channel_type == 1) ? _c('li', {
    attrs: {
      "title": "SMS Campaign"
    }
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card_footer_btn"
  }, [_c('button', {
    staticClass: "btn hf-btn-info card_btn_w btn_h",
    attrs: {
      "title": "Use this scenario"
    },
    on: {
      "click": function($event) {
        _vm.selectScenario(_vm.scenario.id)
      }
    }
  }, [_vm._v("Use This")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-sm card_btn_w btn_h ml-2",
    attrs: {
      "target": "_blank",
      "href": '/previewScenario/' + _vm.scenario.id
    }
  }, [_vm._v("Preview")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-754618c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub_component/scenarioCard.vue
// module id = 1604
// module chunks = 32